import { GalleryVerticalEnd } from "lucide-react";
import * as React from "react";

import { NavbarItems, NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";
import { useGetPersonalInfo } from "@/hooks/workers";

export function AppSidebar({
  items,
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  items: NavbarItems;
}) {
  const { data: user } = useGetPersonalInfo();
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <Company />
        {/* <TeamSwitcher teams={data.teams} /> */}
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={items} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

function Company() {
  return (
    <div className="h-12 text-sm flex items-center gap-2">
      <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
        <GalleryVerticalEnd className="size-4" />
      </div>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-semibold">Tour Manager</span>
      </div>
    </div>
  );
}
